import type { components } from '@/types/openapi';

export type KanatiResponseVisibility =
  components['schemas']['KanatiMessageResponseVisibility'];

export const KANATI_RESPONSE_VISIBILITY = {
  INTERNAL: 'internal',
  PUBLIC: 'public'
} as const satisfies Record<string, KanatiResponseVisibility>;

export const KANATI_RESPONSE_VISIBILITY_LABELS: Record<
  KanatiResponseVisibility,
  { label: string; helpText: string }
> = {
  [KANATI_RESPONSE_VISIBILITY.INTERNAL]: {
    label: 'Internal response',
    helpText: "Kanati's reply will only be visible to internal users."
  },
  [KANATI_RESPONSE_VISIBILITY.PUBLIC]: {
    label: 'Public response',
    helpText: "Kanati's reply will be visible to customers."
  }
};

const DEFAULT_VALUES = {
  attachments: [],
  body: '',
  internal: false,
  kanati_response_visibility: null as KanatiResponseVisibility | null,
  request_human_soc: false,
  ticket_id: 0
};

export default DEFAULT_VALUES;
